import { normalize } from "../../../utils/typeUtils"
import { CreditCard } from "../state/types"
import { DataType } from "../../../tables"
import { useFiltersHooks } from "../../../features/ui"
import { usePaymentOrderLoaders } from "../loaders/paymentOrderLoaders"

export const useCreditCardHooks = () => {
    const { search2 } = useFiltersHooks()

    const paymentOrderLoaders = usePaymentOrderLoaders()

    const describeCreditCardNumber = (last4Numbers: number) => `*-${last4Numbers}`

    const describeCreditCard = (creditCard: CreditCard): string => {
        return `${creditCard.type.toUpperCase()} ${describeCreditCardNumber(creditCard.last4Numbers)}`
    }

    const canRemoveCreditCard = async (creditCardId: string): Promise<boolean> => {
        const { loadPaymentOrdersWithProp } = paymentOrderLoaders()
        const paymentOrdersWithPaymentItems = await loadPaymentOrdersWithProp('paymentItems', true)
        const paymentOrders = paymentOrdersWithPaymentItems.filter(paymentOrder => paymentOrder.paymentItems.some(paymentItem => paymentItem.sourceId === creditCardId))
        return paymentOrders.length === 0
    }

    const searchCreditCards = (
        creditCards: CreditCard[],
        searchText = ''
    ): Promise<CreditCard[]> => {
        const valuesFn = async (creditCardDT: DataType) => {
            const { type, issuer, cardholder, last4Numbers } = creditCardDT as CreditCard
            return [
                normalize(type),
                normalize(issuer),
                normalize(cardholder),
                last4Numbers.toString()
            ]
        }
        const sortFn = (creditCardDT_A: DataType, creditCardDT_B: DataType) => 
            (creditCardDT_A as CreditCard).dueDate.localeCompare((creditCardDT_B as CreditCard).dueDate)

        return search2(creditCards, searchText, valuesFn, undefined, sortFn) as Promise<CreditCard[]>
    }

    return {
        describeCreditCardNumber,
        describeCreditCard,
        canRemoveCreditCard,
        searchCreditCards
    }
}
